import * as Yup from 'yup';

export const YupId = () => Yup.number().integer();
